export default "__VITE_ASSET__Ca4Vivj5__"